import { IIrisGliderState } from './gliderState/IIrisGliderState';
import { IrisContainer, IIrisContainerConstParam } from './IrisContainer';


export class IrisrawGliderState extends IrisContainer<IIrisGliderState> {
  constructor({ ...args }: IIrisContainerConstParam = {} as IIrisContainerConstParam) {
    super(args, IrisrawGliderState.createIrisrawGliderStateConfig)
  }

  static createIrisrawGliderState(datas: IIrisContainerConstParam) {
    return new IrisrawGliderState(datas)
  }

  static createIrisrawGliderStateConfig(data: IIrisGliderState) {
    return data as IIrisGliderState
  }
}
